import { Input } from '@/components/ui/input'
import type { InputProps } from '../input-props'

export function TextInput({ value, onChange, onBlur, disabled, invalid }: InputProps) {
  return (
    <Input
      value={(value as string) ?? ''}
      onChange={(e) => onChange(e.target.value)}
      onBlur={onBlur}
      disabled={disabled}
      aria-invalid={invalid || undefined}
      dir="auto"
    />
  )
}
